import * as React from 'react';
import { History } from 'history';
import { Text } from './text';
import AppService, { textsize } from '../services/app.service';

interface Props {
  history?: History;
  id?: string;
  label?: string;
  url?: string;
  logoUrl?: string;
  titleColor?: any;
  size?: textsize;
}

export const Logo : React.FunctionComponent<Props> = (props) => {
  const [image, setImage] = React.useState<any>();
  const path = props.logoUrl || '/assets/logo.png';

  React.useEffect(() =>  {
    AppService.checkIsImage(path).then(rp => setImage(rp? path : ''))
  }, [])
  
  return (
    <Text label={props.label || (image? '' : document.title)} color={props.titleColor || 'primary.main'} size={props.size || 'extralarge'} bold icon={image || (document.querySelector("link[rel~='icon']") as HTMLAnchorElement).href} iconSize={props.size || 'superlarge'} iconNoAutoHeight={!!image} onClick={() => props.history?.push(props.url || '/')} />
  );
}
